
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import Toaster from 'containers/Toaster'
import GoogleAnalytics from 'components/GoogleAnalytics'
import Divvit from 'components/Divvit'

const GOOGLE_ANALYTICS_APP_ID = __GOOGLE_ANALYTICS_APP_ID__
const DV_FRONTEND_ID = __DV_FRONTEND_ID__
const DIVVIT_SCRIPT_URL = __DIVVIT_SCRIPT_URL__

export default class BaseLayout extends React.Component {
  render() {
    return (
      <div className='base-layout'>
        <Divvit frontendId={DV_FRONTEND_ID} divvitTagUrl={DIVVIT_SCRIPT_URL} />
        <GoogleAnalytics appID={GOOGLE_ANALYTICS_APP_ID} />
        <Toaster />
        {this.props.children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./client/layouts/BaseLayout/index.js